// Local, instant hint of whether this browser has previously been signed in.
//
// The real source of truth is the HTTP-only session cookie, which only the
// backend can validate — and that validation can take 15-30s when the Cloud
// Run API is cold-starting. The hint lets route guards make a good-enough
// decision immediately (show the login form / redirect to /login) instead of
// holding every visitor on a spinner until the server wakes up. Guards treat
// it strictly as a hint: the checkAuth() result always wins once it resolves,
// so a stale hint self-corrects with at most a brief flash.
//
// localStorage access is wrapped in try/catch because it can throw in some
// privacy modes (older Safari private browsing, blocked third-party storage).
// When storage is unavailable we report "no hint", which degrades to showing
// the login form immediately — the safe, fast default.

const AUTH_HINT_KEY = "zen_auth_hint";

export function hasAuthHint() {
  try {
    return localStorage.getItem(AUTH_HINT_KEY) === "1";
  } catch {
    return false;
  }
}

export function setAuthHint(isSignedIn) {
  try {
    if (isSignedIn) {
      localStorage.setItem(AUTH_HINT_KEY, "1");
    } else {
      localStorage.removeItem(AUTH_HINT_KEY);
    }
  } catch {
    // Storage unavailable — guards will just fall back to hint-less behavior.
  }
}
